<template>
  <div class="wbench-log-table">
    <el-timeline v-if="tableData.length > 0">
      <el-timeline-item
        v-for="(item, index) in tableData"
        :key="index"
        :timestamp="item.createTime"
        placement="top"
      >
        <el-card>
          <p>{{ item.logMsg }}</p>
        </el-card>
      </el-timeline-item>
    </el-timeline>
    <el-timeline v-else class="timeline-hide">
      <el-timeline-item>
        <el-card>
          <p>暂无日志</p>
        </el-card>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>

<script>
import Api from "../../api/index";
import request from "../../api/request";
import { getCookie } from "@szgc/plt-core-v2";
import { dateFormat } from "../../util";

export default {
  name: "WbenchLogTable",
  props: {
    businessId: {
      type: [String, Number],
      default: ""
    },
    logType: {
      type: [String, Number],
      default: "all"
    }
  },
  data() {
    return {
      bid: "",
      filterText: "",
      tableData: [],
      prefix: ""
    };
  },
  watch: {
    businessId: {
      async handler(val) {
        if (val) {
          this.prefix = getCookie("plt-api-route") || "";
          this.bid = val;
          this.tableData = [];
          this.getTableData();
        }
      },
      immediate: true
    }
  },
  methods: {
    /*获取事项日志列表*/
    async getTableData() {
      try {
        const { success, data, message } = await request({
          url:
            this.prefix +
            Api.getLogLists({
              businessId: this.bid
            }),
          method: "get"
        });
        if (!success) {
          this.$message.error("获取事项日志列表失败:" + message);
          return false;
        }
        const temp = [];
        if (data && data.length > 0) {
          data.map((item) => {
            item.createTime = dateFormat(item.createTime, "YYYY-MM-DD HH:mm:ss");
            temp.unshift(item);
          });
        }
        this.tableData = temp;
      } catch (error) {
        this.$message.error("获取事项日志列表失败:" + error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wbench-log-table {
  padding: 20px;
  //margin-bottom: 20px;

  ::v-deep .el-timeline {
    .el-timeline-item {
      padding-bottom: 15px;

      .el-timeline-item__timestamp {
        color: var(--szgc-element-primary);
      }

      .el-card {
        .el-card__body {
          padding: 10px 5px;
          color: #606266;
        }
      }
    }

    &.timeline-hide {
      .el-timeline-item__wrapper {
        padding-left: 0;
      }
    }
  }
}
</style>

